<template>
  <div class="policy">
    <img src="@/assets/img/pic_banner.png" alt />
    <div class="nav_pos">
      当前位置：
      <label class="index" @click.stop="$router.push('/')">首页</label>
      > 用户注册
    </div>
    <!-- <div class="nav_pos">
      <span class="text">当前位置：</span>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item
          v-for="(item, index) in $route.meta.breadUrl"
          :key="index"
        >
          <router-link v-if="item.url" :to="item.url">{{
            item.name
          }}</router-link>
          <a v-else>
            {{ item.name }}
          </a>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>-->
    <Steps :active="0"></Steps>
    <div class="title">GRGT电子采购系统服务条款协议</div>
    <div class="content">
      <div class="text">
        <div class="headline">
          欢迎阅读GRGT（广电计量检测集团股份有限公司及其下属分子公司，以下简称“广电计量”）电子采购系统平台（以下简称平台）服务条款协议(下称"本协议")。本协议阐述之条款和条件适用于您使用本平台所提供的电子采购活动的各种工具和服务(下称"服务")。
        </div>
        <div class="head1">1.谁可使用本平台</div>
        <p>
          &nbsp;&nbsp;
          本平台是广电计量电子采购系统平台，供应商入库、招标公告发布、标书的制作、投标文件的上传、开标、评标、评标结果公告、评标结果公示、投诉、质疑等全流程均在本平台进行。"服务"仅供能够根据相关法律订立具有法律约束力的合约，作为潜在供应商的公司和个人及其它招投标相关的工作人员使用。如不符合本项条件，请勿使用"服务"。
          <span class="boldred">本平台可随时自行全权决定驳回向任何单位和个人提供"服务"。</span>"服务"不会提供给被暂时停止或终止资格的本平台注册会员。
        </p>
        <div class="head1">2.接受条款</div>
        <p>
          <span class="bolderd"
            >以任何方式进入本平台即表示您同意已经签订本协议，视为您已理解并完全同意本协议的各项内容，且接受本协议的条款约束。本平台可随时决定更改"条款"。</span
          >如"条款"有任何变更，本平台将在其网上刊载公告，通知予您。如您不同意相关变更，必须停止使用"服务"。经修订的"条款"一经在本平台公布后，立即自动生效。<span
            class="boldred"
            >您应在登录前仔细阅读修订后的"条款"，并有权选择继续或停止使用"服务"；一旦您继续使用"服务"，则表示您已接受经修订的"条款"，当您与本平台发生争议时，应以最新的服务协议为准。</span
          >
        </p>
        <p class="boldred">除本平台另有明确声明外，任何使"服务"范围扩大或功能增强的新内容均受本协议约束。</p>
        <div class="head1">3.您的资料</div>
        <p>
          "您的资料"包括您在注册、购标、答疑、投标、澄清、评标等过程中，以任何网络形式向本平台传送的任何资料，包括数据、文本、照片、图画、影像或其他材料。您应对"您的资料"负全部责任，倘若本平台认为"您的资料"可能使我方承担任何法律或道义上的责任，则本平台可自行全权决定对"您的资料"采取本平台认为必要或适当的任何行动，包括但不限于删除该类资料。您特此保证，您对提交给本平台的"您的资料"拥有全部合法权利且符合本协议规则。
        </p>
        <div class="head1">4.注册</div>
        <div class="head2">4.1注册义务</div>
        <p class="boldred">
          在本平台注册，意味着您同意：(a) 根据本平台刊载的会员资料表格的要求，提供关于您的真实、准确、完整和反映当前情况的资料； (b)
          维护并及时更新会员资料，使其保持真实、准确、完整和反映当前情况。
        </p>
        <p>
          倘若您提供任何不真实、不准确、不完整或不能反映当前情况的资料，或本平台有合理理由认为资料不真实、不准确、不完整或不能反映当前情况，本平台有权暂停或终止您的注册会员资格，并驳回您在目前或将来对"服务"(或其任何部份)
          以任何形式使用。
        </p>
        <p class="boldred">
          如您个人代表一家公司或其他法律主体在本平台登记，则您声明和保证，您已取得相应授权或有权使该公司或其他法律主体受本协议"条款"约束。
        </p>
        <div class="head2">4.2会员注册名、密码和保密</div>
        <p>
          4.2.1在登记过程中，您将选择会员注册名和设置密码。您须自行负责对您的会员注册名和密码保密，且须对您在会员注册名和密码下发生的所有活动承担责任。您同意：(a)
          如发现任何人未经授权使用您的会员注册名或密码，或发生违反保密规定和约定的任何其他情况，您会立即通知本平台；及 (b)
          确保您在每个登录时段结束时，以正确步骤离开本平台。本平台不能也不会对因您未能遵守本款规定而发生的任何损失或损毁负责。
        </p>
        <p>
          4.2.2只有根据广电计量要求购买北京数字认证股份有限公司（简称北京CA）提供的单位数字证书（certificate
          authority），缴纳相应的会员费用，并在本平台成功注册的用户，才能进行电子招投标等活动。
        </p>
        <p>
          4.2.3您在本平台上由北京CA实现电子签章、加密或解密的所有文件，<span class="boldred"
            >本平台无需为此承担您的数据在传输、加密等安全性方面的责任。</span
          >
        </p>
        <div class="head2">4.3关于您的资料的规则</div>
        <p>您同意，您供给本平台的资料</p>
        <p>a. 不会有欺诈（包括制造谣言、传播谣言等）成份；</p>
        <p>b. 不会侵犯任何第三者的版权、专利、商标、商业秘密或其他知识产权，或隐私权、名誉权；</p>
        <p>c. 不会违反任何法律、法规、条例或规章；</p>
        <p>d. 不会含有诽谤（包括商业诽谤）、非法恐吓或非法骚扰的内容；</p>
        <p>e. 不会含有淫秽、或包含任何色情内容；</p>
        <p>f. 不会含有蓄意毁坏、恶意干扰、秘密地截取或侵占任何系统、数据或个人资料的任何病毒、伪装破坏程序、电脑蠕虫、定时程序炸弹或其他电脑程序；</p>
        <p>
          g.您同意不会：（I）在与任何连锁信件、大量胡乱邮寄的电子邮件、滥发电子邮件或任何复制或多余的信息有关的方面使用"服务"；(II)
          未经其他人士同意，利用"服务"收集其他人士的电子邮件地址及其他资料；或 (III)
          利用"服务"制作虚假的电子邮件地址，或以其他形式试图在发送人的身份或信息的来源方面误导其他人士。
        </p>
        <div class="head1">5.您授予本平台运营方的许可使用权</div>
        <p><span class="boldred"> 您授予本平台运营方有权合理地使用"您的资料"。</span>本平台承诺，您在投标过程中来往的所有文件将被依法保密。</p>
        <div class="head1">6.系统完整性</div>
        <p>
          您同意，您不得使用任何装置、软件或例行程序干预或试图干预本平台的正常运作。您不得采取对任何将不合理或不合比例的庞大负载加诸本平台网络结构的行动。您不得向任何第三者披露您的密码，或与任何第三者共用您的密码，或为任何未经批准的目的使用您的密码。
        </p>
        <div class="head1">7.不作商业性利用</div>
        <p>
          您同意，您不得对任何资料作商业性利用，包括但不限于在未经本平台运营方书面批准的情况下，复制在本平台上展示的任何资料，包括系统的功能结构和画面等。
        </p>
        <div class="head1">8.终止或访问限制</div>
        <p>
          <span class="boldred"
            >您同意，在本平台未向您收费的情况下，可自行全权决定以任何理由
            (包括但不限于本平台认为您已违反本协议的字面意义和精神，或您以不符合本协议的字面意义和精神的方式行事)终止您的"服务"密码、账户
            (或其任何部份) 或您对"服务"的使用，并删除和丢弃您在使用"服务"中提交的 "您的资料"。</span
          >您同意，在本平台向您收费的情况下，本平台应基于合理的怀疑且不经电子邮件通知的情况下实施上述终止服务的行为。本平台同时可自行全权决定，在发出通知或不发出通知的情况下，随时停止提供"服务"或其任何部分。您同意，根据本协议的任何规定终止您使用"服务"之措施可在不发出事先通知的情况下实施，并承认和同意，本平台可立即使您的账户无效，或撤销您的账户以及在您的账户内的所有相关资料，和/或禁止您进一步接入该等资料或"服务"。账户终止后本平台没有义务为您保留原账户中或与之相关的任何信息，或转发任何未曾阅读或发送的信息给您或第三方。此外，您同意，本平台不会就终止您接入"服务"而对您或任何第三者承担任何责任。
        </p>
        <div class="head1">9.服务"按现状"提供</div>
        <p>
          <span class="boldred">
            本平台不能随时预见到任何技术上的问题或其他困难。该等困难可能会导致数据损失或其他服务中断。为此，您明确理解和同意，您使用"服务"的风险由您自行承担。</span
          >"服务"以"按现状"和"按可得到"的基础提供。<span class="boldred"
            >本平台明确声明不作出任何种类的所有明示或暗示的保证，包括但不限于关于适销性、适用于某一特定用途和无侵权行为等方面的保证。</span
          >本平台对下述内容不作保证：(i)"服务"会符合您的要求；(ii)"服务"不会中断，且适时、安全和不带任何错误；(iii)
          通过使用"服务"而可能获取的结果将是准确的；及 (iv) 您通过"服务"而获得的体验是合理的。
        </p>
        <div class="head1">10.无代理关系</div>
        <p>您与本平台仅为独立订约人关系。本协议无意结成或创设任何代理、合伙、合营、雇用。</p>
        <div class="head1">11.不可抗力</div>
        <p>
          对于因本平台合理控制范围以外的原因，包括但不限于自然灾害、罢工或骚乱、暴动、战争行为、政府行为、通讯或其他设施故障或严重伤亡事故等，致使本平台延迟或未能履约的，本平台不对您承担任何责任。
        </p>
        <div class="head1">12.其他规定</div>
        <p>
          本协议各方面应受中华人民共和国大陆地区法律的管辖。倘若本协议任何规定被裁定为无效或不可强制执行，该项规定应被撤销，而其余规定应予执行。条款标题仅为方便参阅而设，并不以任何方式界定、限制、解释或描述该条款的范围或限度。本平台未就您或其他人士的某项违约行为采取行动，并不表明本平台撤回就任何继后或类似的违约事件采取行动的权利。
        </p>
        <div class="head1">13.诉讼</div>
        <p class="boldred">
          因本协议或本服务所引起或与其有关的任何争议应向本协议签订地法院广州市天河区法院提起诉讼，并以中华人民共和国法律为管辖法律。
        </p>
      </div>
      <div style="text-align: center" ref="agreenCheckWrap">
        <el-checkbox v-model="agreen" :disabled="isPermit" ref="agreenCheck">我已阅读《GRGT电子采购系统服务条款协议》</el-checkbox>
        <span v-if="isPermit">请仔细阅读，{{ times }}秒后可勾选</span>
      </div>
    </div>
    <div class="btn_wrap">
      <span class="btn_1 btn_1_1" @click="back">不同意</span>
      <span class="btn_1" @click="submit">同意</span>
    </div>
  </div>
</template>

<script>
import Steps from '@/components/common/Steps'
export default {
  components: { Steps },
  data() {
    return {
      times: 30,
      isPermit: true,
      agreen: false,
      flag: true
    }
  },
  mounted() {
    window.addEventListener('scroll', this._scroll)
  },
  methods: {
    _scroll() {
      if (this.flag) {
        var visibleBottom = window.scrollY + document.documentElement.clientHeight //滚动条高度+视窗高度 = 可见区域底部高度
        var visibleTop = window.scrollY //可见区域顶部高度
        var centerY = this.$refs.agreenCheck.$el.offsetTop + 480
        var show = centerY > visibleTop && centerY < visibleBottom
        if (show) {
          //开始计时
          this.flag = false
          this.setCheckbox()
        }
      }
    },
    setCheckbox() {
      var timer = setInterval(() => {
        this.times--
        if (this.times === 0) {
          this.isPermit = false
          clearInterval(timer)
        }
      }, 1000)
    },
    submit() {
      if (this.agreen == false) {
        var cc = this.$message('请先勾选同意协议')
        setTimeout(() => {
          cc.close()
        }, 1000)
        return
      }
      this.$router.push('/register')
    },
    back() {
      this.$router.push('/')
    }
  }
}
</script>

<style lang="scss" scoped>
.policy {
  .btn_wrap {
    width: 500px;
    margin: 35px auto 50px;
    .btn_1 {
      font-weight: bold;
      margin: 0 30px;
    }
    .btn_1_1 {
      background: #fff;
    }
  }
  .title {
    height: 100px;
    line-height: 100px;
    color: #0774c5;
    font-weight: bold;
    font-size: 16px;
    text-align: center;
  }
  .boldred {
    color: #f80303;
    font-weight: bold;
  }
  .content {
    width: 68%;
    margin: 0 auto;
    .text {
      margin-bottom: 40px;
      line-height: 25px;

      div {
        font-weight: bold;
        margin: 20px 0;
      }
      .headline {
        font-weight: bold;
      }
      p {
        margin: 20px 0;
        text-indent: 2em;
      }
    }
  }
}
</style>
